module.exports = __webpack_public_path__ + "img/pethouse50.1bbce237.jpg";